export default "__VITE_ASSET__eSNKDLjg__"